<!-- the design's split: an 8px frame and gap, then 3/8 for the
     testimonial and 5/8 for the form panel (grid tracks, so the panel's
     padding doesn't skew the ratio) -->
<div
  class="grid min-h-dvh grid-cols-1 gap-2 bg-zinc-975 p-2 font-brand text-zinc-100"
  [ngClass]="{ 'xl:grid-cols-[3fr_5fr]': testimonial() }">
  @if (testimonial()) {
    <aside class="hidden min-w-0 items-center justify-center xl:flex">
      <figure
        class="relative isolate flex h-108.25 w-81.25 flex-col justify-between overflow-hidden rounded-[20px] bg-zinc-950 p-5">
        <!-- the design's texture, tinted blue and faded like in Framer -->
        <img
          src="./assets/images/auth/testimonial-bg.png"
          alt=""
          class="absolute inset-0 -z-10 size-full object-cover opacity-20 hue-rotate-214"
          aria-hidden="true" />
        <figcaption class="flex items-center gap-2.5">
          <span
            class="size-2 rounded-xs bg-accent-500"
            aria-hidden="true"></span>
          <span
            class="font-mono text-[11px] tracking-[0.1em] text-zinc-200 uppercase">
            {{ 'pages.register.convince.testimonial.name' | transloco }}
          </span>
        </figcaption>
        <blockquote class="text-lg leading-snug tracking-tight text-zinc-100">
          {{ 'pages.register.convince.testimonial.testimonial' | transloco }}
        </blockquote>
      </figure>
    </aside>
  }

  <main
    class="relative flex min-w-0 items-center justify-center rounded-2xl bg-zinc-960 px-4 py-12 inset-ring inset-ring-zinc-950">
    <app-language-switch class="absolute top-4 right-4" />
    <div
      class="flex w-full flex-col"
      [ngClass]="{ 'max-w-100': !wide(), 'max-w-140': wide() }">
      <ng-content></ng-content>
    </div>
  </main>
</div>
